<template>
    <AppLayout title="Crear Envios Excel">
        <Toast />
        <Breadcrumb route="carga_excel" page="Carga Multiple via Excel" />
        <form class="p-2">
            <div class="flex flex-col lg:flex-row lg:w-full">
                <div class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:w-1/2">
                    <form enctype="multipart/form-data" class="p-2">
                        <div class="flex flex-col h-24">
                            <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Seleccione el archivo a cargar</label>
                            <input type="file" @input="form.archivo = $event.target.files[0]" class="block w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 cursor-pointer dark:text-gray-400 focus:outline-none focus:border-transparent dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400">
                            <div class="mt-1 text-sm text-gray-500 dark:text-gray-300" >El archivo debe ser tipo excel</div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="cargarExcel" :disabled="noDisponible"> Cargar Archivo </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
    },
    props: {
        errors: Object
    },
    data() {
        return {
            noDisponible: false,
            form: this.$inertia.form({
                archivo: null,
            }),
        };
    },
    methods: {
        cargarExcel() {
            this.noDisponible = true;
            this.form.post(`/recibir_excel`, {
                onSuccess: () => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Exito",
                        detail: "Archivo Cargado con Exito",
                        life: 3000,
                    });
                    this.noDisponible = false;
                },
                onError: () => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        detail: "El archivo debe ser tipo Excel",
                        life: 3000,
                    });
                    this.noDisponible = false;
                },
            });
        }
    }
};

</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>